"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = exports.createC2DMessage = void 0;
const effect_1 = require("effect");
const common_1 = require("../common");
const message_1 = require("./message");
const createGetConsumablesCommand = (namespace) => (0, message_1.createMessage)('command', effect_1.Schema.Struct({ command: effect_1.Schema.tag('consumables.get') })).annotations({
    identifier: `${namespace}.GetConsumablesCommand`,
    title: 'Get Consumables Command',
    description: 'Instruct the device to send a consumable State meassage',
});
const getConsumableCatalogueMessage = (namespace, catalogue) => (0, message_1.createMessage)('consumable', common_1.Consumable.createCatalogueMessage(namespace, catalogue)).annotations({
    identifier: `${namespace}.ConsumableCatalogueMessage`,
    title: 'Catalogue',
    description: 'Sends the catalogue of consumables compatible with the device',
});
const getUpdateConsumableMessage = (namespace, slots) => (0, message_1.createMessage)('consumable', common_1.Consumable.createUpdateConsumableMessage(namespace, slots)).annotations({
    identifier: `${namespace}.UpdateConsumableMessage`,
    title: 'Update Consumables',
    description: 'Sends an update of the consumables installed in each slot of the device',
});
const createC2DMessage = (namespace, slots, catalogue) => effect_1.Schema.Union(getConsumableCatalogueMessage(namespace, catalogue), getUpdateConsumableMessage(namespace, slots), createGetConsumablesCommand(namespace)).annotations({
    identifier: `${namespace}.ConsumableC2DMessage`,
    title: 'Consumable Message',
    description: 'A Cloud-To-Device message related to consumables',
});
exports.createC2DMessage = createC2DMessage;
const createD2CMessage = (namespace, slots) => (0, message_1.createMessage)('consumable', effect_1.Schema.Union(common_1.Consumable.createRequestCatalogueMessage(namespace), common_1.Consumable.createStateMessage(namespace, slots))).annotations({
    identifier: `${namespace}.ConsumableD2CMessage`,
    title: 'Consumable Message',
    description: 'A Device-To-Cloud message on the "consumable" channel',
});
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=consumable.js.map